import $, { each } from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from 'vanilla-lazyload'
import ModalVideo from 'modal-video'
import { gsap } from "gsap";
import 'jquery-modal'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic', slidesNumber = 1) => {
  const $el = $(el)
  const opts = {
    basic: {
      dots: true,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
    },
    // MESSAGES
    message: {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1500,
      easing: 'ease-out',
    },
    // COMMON
    postSlider: {
      slidesToShow: 3,
      prevArrow: $('.section--common-post-slider .section__arrow-prev'),
      nextArrow: $('.section--common-post-slider .section__arrow-next'),
      responsive: [{
        breakpoint: 832,
        settings: {
          slidesToShow: 1,
        }
      }]
    },
    relatedPost: {
      arrows: false,
      variableWidth: true,
      centerMode: true,
      mobileFirst: true,
      responsive: [{
        breakpoint: 832,
        settings: "unslick"
      }]
    },
    horecaCommonEvents: {
      prevArrow: $('.section--common-horeca-events .section__arrow-prev'),
      nextArrow: $('.section--common-horeca-events .section__arrow-next'),
    },
    // PROMOTED RECIPE
    promotedRecipes: {
      prevArrow: $('.section--common-promoted-recipes .section__arrow-prev'),
      nextArrow: $('.section--common-promoted-recipes .section__arrow-next')
    },
    // BRAND
    brandMain: {
      infinite: false,
      asNavFor: '.brand__slider-nav',
      prevArrow: $('.brand__arrow-prev'),
      nextArrow: $('.brand__arrow-next')
    },
    brandNav: {
      arrows: false,
      infinite: false,
      slidesToShow: 5,
      asNavFor: '.brand__slides-wrapper',
      focusOnSelect: true,
      variableWidth: true,
    },
    brandRelatedMain: {
      variableWidth: true,
      centerMode: true,
      mobileFirst: true,
      asNavFor: '.brand--related .brand__list-mobile',
      responsive: [{
        breakpoint: 832,
        settings: "unslick"
      }]
    },
    brandRelatedSecondary: {
      arrows: false,
      variableWidth: true,
      centerMode: true,
      mobileFirst: true,
      asNavFor: '.brand--related .brand__list-wrapper',
      responsive: [{
        breakpoint: 832,
        settings: "unslick"
      }]
    },
    // PL
    plMain: {
      infinite: false,
      asNavFor: '.private-label__slider-nav',
      prevArrow: $('.private-label__arrow-prev'),
      nextArrow: $('.private-label__arrow-next')
    },
    plNav: {
      arrows: false,
      infinite: false,
      slidesToShow: 5,
      asNavFor: '.private-label__slides-wrapper',
      focusOnSelect: true,
      variableWidth: true,
    },
    // ARCHIVE BRAND
    archiveBrandsMain: {
      variableWidth: true,
      centerMode: true,
      prevArrow: $('.section--archive-brand-food-service .section__arrow-prev'),
      nextArrow: $('.section--archive-brand-food-service .section__arrow-next'),
      asNavFor: '.section__brand-icon-slider',
      responsive: [{
        breakpoint: 832,
        settings: {
          centerMode: false
        }
      }]
    },
    archiveBrandsIcons: {
      arrows: false,
      fade: true,
      asNavFor: '.section__brand-slider',
    },
    archiveBrandsTech: {
      prevArrow: $('.section--archive-brand-technology .section__arrow-prev'),
      nextArrow: $('.section--archive-brand-technology .section__arrow-next')
    },
    archiveBrandsBenefits: {
      asNavFor: '.section__benefits-nav',
      prevArrow: $('.section--archive-brand-benefits .section__arrow-prev'),
      nextArrow: $('.section--archive-brand-benefits .section__arrow-next')
    },
    archiveBrandsBenefitsNav: {
      arrows: false,
      slidesToShow: 8,
      asNavFor: '.section__benefits-main',
      focusOnSelect: true,
      responsive: [{
        breakpoint: 832,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
        }
      }]
    },
    // ARCHIVE BRAND + ARCHIVE PL
    archivePrivateLabels: {
      variableWidth: true,
      infinite: false,
      mobileFirst: true,
      prevArrow: $('.section--archive-brand-services .section__arrow-prev, .section--archive-pl-list .section__arrow-prev'),
      nextArrow: $('.section--archive-brand-services .section__arrow-next, .section--archive-pl-list .section__arrow-next'),
      responsive: [{
        breakpoint: 832,
        settings: "unslick"
      }]
    },
    archivePrivateLabelsCenter: {
      variableWidth: true,
      centerMode: true,
      mobileFirst: true,
      responsive: [{
        breakpoint: 832,
        settings: "unslick"
      }]
    },
    // ARCHIVE PL
    archivePlMain: {
      infinite: false,
      asNavFor: '.section__slider-nav',
      prevArrow: $('.section__arrow-prev'),
      nextArrow: $('.section__arrow-next')
    },
    archivePlNav: {
      arrows: false,
      infinite: false,
      slidesToShow: 5,
      asNavFor: '.section__slides-wrapper',
      focusOnSelect: true,
      variableWidth: true,
    },
    // DEFAULT
    defaultMainDark: {
      infinite: false,
      asNavFor: '.section__row-dark .section__slider-nav',
      prevArrow: $('.section__row-dark .section__arrow-prev'),
      nextArrow: $('.section__row-dark .section__arrow-next')
    },
    defaultNavDark: {
      arrows: false,
      infinite: false,
      slidesToShow: 5,
      asNavFor: '.section__row-dark .section__slides-wrapper',
      focusOnSelect: true,
      variableWidth: true,
    },
    defaultMainMid: {
      infinite: false,
      asNavFor: '.section__row-mid .section__slider-nav',
      prevArrow: $('.section__row-mid .section__arrow-prev'),
      nextArrow: $('.section__row-mid .section__arrow-next')
    },
    defaultNavMid: {
      arrows: false,
      infinite: false,
      slidesToShow: 5,
      asNavFor: '.section__row-mid .section__slides-wrapper',
      focusOnSelect: true,
      variableWidth: true,
    },
    defaultMainLight: {
      infinite: false,
      asNavFor: '.section__row-light .section__slider-nav',
      prevArrow: $('.section__row-light .section__arrow-prev'),
      nextArrow: $('.section__row-light .section__arrow-next')
    },
    defaultNavLight: {
      arrows: false,
      infinite: false,
      slidesToShow: 5,
      asNavFor: '.section__row-light .section__slides-wrapper',
      focusOnSelect: true,
      variableWidth: true,
    },
    defaultCards: {
      slidesToShow: 3,
      prevArrow: $('.section--default-content .section__arrow-prev'),
      nextArrow: $('.section--default-content .section__arrow-next'),
      responsive: [{
        breakpoint: 832,
        settings: {
          slidesToShow: 1,
        }
      }]
    },
    // POST
    postGallery: {
      prevArrow: $('.post__gallery-caption .post__arrow-prev'),
      nextArrow: $('.post__gallery-caption .post__arrow-next'),
      variableWidth: true,
      centerMode: true,
    },
    // ARCHIVE POST / HORECA
    promotedPosts: {
      prevArrow: $('.section--archive-post-promoted .section__arrow-prev'),
      nextArrow: $('.section--archive-post-promoted .section__arrow-next')
    },
    horecaEvents: {
      slidesToShow: 3,
      prevArrow: $('.section--horeca-events .section__arrow-prev'),
      nextArrow: $('.section--horeca-events .section__arrow-next'),
      responsive: [{
        breakpoint: 832,
        settings: {
          slidesToShow: 1,
        }
      }]
    },
    horecaNovelty: {
      slidesToShow: 3,
      prevArrow: $('.section--horeca-novelty .section__arrow-prev'),
      nextArrow: $('.section--horeca-novelty .section__arrow-next'),
      responsive: [{
        breakpoint: 832,
        settings: {
          slidesToShow: 1,
        }
      }]
    },
    // ABOUT
    aboutSlider: {
      prevArrow: $('.section--about-slider .section__arrow-prev'),
      nextArrow: $('.section--about-slider .section__arrow-next')
    },
    aboutBenefits: {
      asNavFor: '.section__numbers-nav',
      prevArrow: $('.section--about-numbers .section__arrow-prev'),
      nextArrow: $('.section--about-numbers .section__arrow-next')
    },
    aboutBenefitsNav: {
      arrows: false,
      slidesToShow: 5,
      asNavFor: '.section__numbers-main',
      focusOnSelect: true,
      responsive: [{
        breakpoint: 832,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
        }
      }]
    },
    aboutStory: {
      fade: true,
      infinite: true,
      asNavFor: '.section--about-story .section__numbers, .section--about-story .section__dots, .section--about-story .section__story-gallery',
      prevArrow: $('.section--about-story .section__arrow-prev'),
      nextArrow: $('.section--about-story .section__arrow-next')
    },
    aboutStoryGallery: {
      fade: true,
      infinite: true,
      asNavFor: '.section--about-story .section__story-container',
    },
    aboutStoryNav: {
      arrows: false,
      infinite: true,
      focusOnSelect: true,
      slidesToShow: slidesNumber,
      asNavFor: '.section--about-story .section__story-container, .section--about-story .section__story-gallery',
    },
  }

  $el.on('init',function(){
    $(".slick-slide").removeClass('slick-next slick-prev')
    $(".slick-current").prev().addClass('slick-prev')
    $(".slick-current").next().addClass('slick-next')
  })

  $el.slick(opts[type]).on('afterChange',function(){
    $(".slick-slide").removeClass('slick-next slick-prev')
    $(".slick-current").prev().addClass('slick-prev')
    $(".slick-current").next().addClass('slick-next')
  })

  // $(document).on('facetwp-refresh', function($el) {
  //   if ($('body').hasClass('post-type-archive-product') || $('body').hasClass('post-type-archive-recipe')) {
  //     console.log('refresh')
  //   }
  // })
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    // elements_selector: ".lazy",
    // data_src: "lazy",
  })
}

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"]):not([href*="#modal"]):not([class*="a2a_button_"]):not([href*="#form"])').click(function(e) {
    const target = $(this.hash)
    if (target.length > 1) e.preventDefault()
    $('html, body').animate({ scrollTop: target.offset().top-100 }, 1000)
  })

  $("a[href='#top']").click(function(e) {
    e.preventDefault()
    $('html, body').animate({ scrollTop: 0 }, 800)
  })
}

/* SCROLL TO ANCHOR
  ----------------------------- */
export const scrollToAnchor = () => {
  if (window.location.hash) {
    var hash = window.location.hash.substring(1)
    $('html, body').animate({ scrollTop: $('#' + hash).offset().top-100 }, 1000)
  }
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const close = $('.header--offcanvas .header__close')
  const header = $('.header--main')

  toggle.on('click', function () {
    overlay.addClass('open')
    toggle.addClass('open')
  })

  close.on('click', function () {
    overlay.removeClass('open megamenu-open')
    toggle.removeClass('open')
  })

  $('.menu--primary .menu-item-megamenu a').on('click', function(e) {
    const megaMenu = $(this).parent().attr('class').split(' ')[1]

    if ($('.block--'+ megaMenu).hasClass('megamenu-open')) {
      $('.menu-item').removeClass('menu-item-open')
      $('.block--megamenu, .header__inner, .wrapper-megamenu').removeClass('megamenu-open')
    } else {
      $('.menu-item').removeClass('menu-item-open')
      $('.block--megamenu, .header__inner, .wrapper-megamenu').removeClass('megamenu-open')
      $(this).parent().addClass('menu-item-open')
      $('.block--' + megaMenu +',.header__inner, .wrapper-megamenu').addClass('megamenu-open')
    }

    e.preventDefault()
  })

  $('.content-area, .block__back').on('click', function() {
    $('.block--megamenu, .header__inner').removeClass('megamenu-open')
    $('.menu-item').removeClass('menu-item-open')
  })

  $('.block__offcanvas-toggle').on('click', function() {
    $(this).toggleClass('toggle-open').parent().next().slideToggle()
  })

  // Lang Menu
  $(".header__service-item.header__service-lang").click(function() {
    $(".menu--lang").toggleClass("open_lang")
  })

  // Right Menu Item
  $('<ul class="menu menu--primary m0 p0"></ul>')
    .append($(".header__menu-wrapper .menu--primary .menu-item-right").prependTo('.header__service-menu'))
    .prependTo('.header__service-menu')

  // Sticky
  $(document).scrollTop() > 50 ?
    header.addClass('sticky') :
    header.removeClass('sticky')

  $(window).scroll(function() {
    $(document).scrollTop() > 50 ?
      header.addClass('sticky') :
      header.removeClass('sticky')
  })
}

/* SEARCH ANIMATION
  ----------------------------- */
export const setupSearchOverlay = () => {
  $('.header__service-search').on('click', function() {
    $('.block--search-overlay, .header__inner').addClass('search-open')
    $('.block--megamenu, .header__inner').removeClass('megamenu-open')
    $('.menu-item').removeClass('menu-item-open')
    $('.header--offcanvas, .header__inner').removeClass('open')
    $('.block__search-input').focus()
  })

  $('.block--search-overlay .block__close').on('click', function() {
    $('.block--search-overlay,.header__inner').removeClass('search-open')
  })
}

/* SETUP MEGAMENU
  ----------------------------- */
export const setupMegaMenu = () => {
  $('.block--megamenu .block__link-hover, #surgital-sub-menu').on({
    mouseenter: function () {
      let contentID = $(this).data('content')
      $('#' + contentID).css('display','flex').addClass('active')
    },
    mouseleave: function () {
      let contentID = $(this).data('content')
      $('#' + contentID).css('display','none').addClass('active')
    }
  })
}

/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}

/* SETUP JQUERY MODAL
  ----------------------------- */
export const setupJqueryModal = () => {
  const link = $('[href*="#modal"]')

  link.on('click' , function(e) {
    $(this).modal({fadeDuration: 100,})
    e.preventDefault()
  })

  // Modal Welcome Form
  $('[href*="#form-access-rules"]').on('click', function(e) {
    $(this).modal({ 
      fadeDuration: 300,
      escapeClose: false,
      clickClose: false,
      showClose: false
    })
    e.preventDefault()
  })

  $('#form-access-rules').on($.modal.BEFORE_CLOSE, function (event, modal) {
    $('.wpcf7-form-control-wrap[data-name="access-rules"] .wpcf7-list-item-label').trigger("click")
  })

  // if (window.location.hash.indexOf('wpcf7') >= 0) {
  //   var formHash = window.location.hash
  //   $(formHash).parents('.block--modal').modal({fadeDuration: 100,})
  // }
}

/* MODAL FORM DETECT SCROLL
  ----------------------------- */
export const modalFormDetectScroll = () => {
  $('#form-access-rules .form__text-wrapper').on('scroll', function () {
    if ($(this).scrollTop() + $(this).innerHeight() >= this.scrollHeight - 10) {
      $('#form-access-rules .form__modal-link').removeClass('disabled')
    }
  })
}

/* ARCHIVE BRANDS SETUP COLOR
  ----------------------------- */
export const archiveBrandsChangeColor = () => {
  // Init setup
  var mainColor = $('.section__brand-slider .slick-active .preview--brand').attr('data-color-main')
  var secondaryColor = $('.section__brand-slider .slick-active .preview--brand').attr('data-color-secondary')
  var retail = $('.section__brand-slider .slick-active .preview--brand').attr('data-retail')

  $('.section--archive-brand-food-service').css('background-color', secondaryColor)
  $('.section--archive-brand-food-service .section__background').css('background-color', mainColor)
  $('.section--archive-brand-food-service .section__title').text(retail)

  // Change colors before change slide
  $('.section__brand-slider').on('beforeChange',function(event, slick, currentSlide, nextSlide) {
    var nextSlide = $('.section__brand-slider [data-slick-index=' + nextSlide + ']')
    var mainColor = nextSlide.find('.preview--brand').attr('data-color-main')
    var secondaryColor = nextSlide.find('.preview--brand').attr('data-color-secondary')
    var retail = nextSlide.find('.preview--brand').attr('data-retail')

    $('.preview--brand .preview__title-alt').css('opacity', 0)
    $('.section--archive-brand-food-service').css('background-color', secondaryColor)
    $('.section--archive-brand-food-service .section__background').css('background-color', mainColor)
    $('.section--archive-brand-food-service .section__title').text(retail)
  })

  // Re-activate title after change slide
  $('.section__brand-slider').on('afterChange', function() {
    $('.section__brand-slider .slick-slide:not(.slick-active) .preview--brand .preview__title-alt').css('opacity', .4)
  })
}

/* ABOUT NUMBERS SETUP COLOR
  ----------------------------- */
export const aboutChangeColor = () => {
  var color = $('.section__numbers-main .slick-active .section__data-group').attr('data-background-color')
  var selectClass = $('.section__numbers-main .slick-active .section__data-group').attr('data-section-color')

  $('.section--about-numbers').css('background-color', color).addClass(selectClass)
  $('.section--about-numbers .section__number-dot').css('background-color', color)

  $('.section__numbers-main').on('beforeChange',function(event, slick, currentSlide, nextSlide){
    $('.section--about-numbers').removeClass("light dark")
    var nextSlide = $('.section__numbers-main [data-slick-index=' + nextSlide + ']')
    var color = nextSlide.find('.section__data-group').attr('data-background-color')
    var selectClass = nextSlide.find('.section__data-group').attr('data-section-color')

    console.log(nextSlide)
    console.log(color)

    $('.section--about-numbers').css('background-color', color).addClass(selectClass)
    $('.section--about-numbers .section__number-dot').css('background-color', color)
  })
}

/* CHANGE SLIDE TITLES
  ----------------------------- */
export const sliderChangeTitles = (section, title, slider) => {
  var titlePrev = $(section).find('.slick-prev').find(title).html()
  var titleNext = $(section).find('.slick-next').find(title).html()

  $(section).find('[class*="__nav-title-prev"]').html(titlePrev)
  $(section).find('[class*="__nav-title-next"]').html(titleNext)

  $(section).find(slider).on('beforeChange',function(event, slick, currentSlide, nextSlide){
    
    if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
      var nextSlide = $(section).find('[data-slick-index=' + currentSlide + ']')
      var prevSlide = $(section).find('[data-slick-index=' + (slick.$slides.length - 2) + ']')
      // direction = 'prev and loop'
    } else if (nextSlide > currentSlide || (currentSlide === (slick.$slides.length - 1) && nextSlide === 0 )) {
      var nextSlide = $(section).find('[data-slick-index=' + (nextSlide + 1) + ']')
      var prevSlide = $(section).find('[data-slick-index=' + currentSlide + ']')
      // direction = 'next'
    } else {
      var nextSlide = $(section).find('[data-slick-index=' + currentSlide + ']')
      var prevSlide = $(section).find('[data-slick-index=' + (currentSlide - 2) + ']')
      // direction = 'prev'
    }
    
    var titlePrev = prevSlide.find(title).html()
    var titleNext = nextSlide.find(title).html()

    $(section).find('[class*="__nav-title-prev"]').html(titlePrev)
    $(section).find('[class*="__nav-title-next"]').html(titleNext)
  })
}

/* ACCORDION TOGGLE
  ----------------------------- */
export const accordionToggle = () => {
  $('.accordion > [class*="title"]').on('click', function() {
    $(this).parent().toggleClass('open')
    $(this).parent().find('[class*="body"]').slideToggle()
  })

  $('.accordion-mobile > [class*="title"]').on('click', function() {
    $(this).parent().toggleClass('open')
    $(this).parent().next('[class*="body"]').slideToggle()
  })

  // FAQ
  $('.section--work-faq .section__item').on('click', function () {
    $(this).toggleClass('open')
    $(this).find('.section__answer').slideToggle()
  })

  // FAQ ECOMMERCE
  $('.section--landing-faq .section__faq-question').on('click', function () {
    $(this).toggleClass('open')
    $(this).next().slideToggle()
  })
}

/* RECIPE OPEN USED PRODUCT
  ----------------------------- */
// export const recipeUsedProduct = () => {
//   $('[class*="__used-close"],[class*="__used-image"]').on('click', function() {
//     $(this).parents('[class*="__used-products"]').toggleClass('open')
//   })
// }

/* ABOUT SPLIT CHARS
  ----------------------------- */
export const aboutSplitChars = () => {
  $('.section--about-numbers .section__data-text').each(function() {
    const current = $(this)
    const chars = current.text().split('')
    current.empty()

    $.each(chars, function(index, item) {
      let classItem = item == '.' ? 'dot' : item
      current.append('<span class="' + classItem + ' flex items-center justify-center circle">' + item + '</span>')
    })
  })
}

/* WRAP TRADEMARK SYMBOL
  ----------------------------- */
export const wrapTrademarkSymbol = () => {
  if ($('body:contains("®")').length > 0) {
    $('body *:not(.wpcf7):contains("®"):not(:has(*)), body *:not(.wpcf7) p:contains("®"), body *:not(.wpcf7) h1:contains("®"), body *:not(.wpcf7) h2:contains("®"), body *:not(.wpcf7) h3:contains("®")').each(function () {
      if (this.nodeType == 1) {
        $(this).html(function (_, oldValue) {
          return oldValue.replace(/®/g, "<sup>®</sup>")
        })
      } 
    })
  }
}

/* GET UPLOAD FILE
  ----------------------------- */
export const getUploadFile = () => {
  $('input[type="file"]').on('change', function() {
    var file = this.files[0]
    file['size'] > 3000000 ?
      $('.form__upload-message').text('Il file caricato è troppo pesante') :
      $('.form__upload-message').text(file['name']).addClass('file-loaded')
  })
}

/* INSERT CATALOGUE FIELD
  ----------------------------- */
export const populateCatalogueField = () => {
  if ($('.catalogue--link').length > 0) {
    $('.form__input--select select').on('change', function() {
      $('input[name="catalog_pdf_url"]').val($('.catalogue--link').data('pdf'))
      $('input[name="brand-tag"]').val($('.catalogue--link').data('brand'))
    })
  }
}

/* INSERT CATALOGUE FIELD
  ----------------------------- */
export const openSocialShare = () => {
  $('[class*="__tools-item-share"]').on('click', function() {
    $(this).find('.heateor_sss_sharing_container').toggleClass('open')
  })
}

/* APPEND SEARCH ON ARCHIVE
  ----------------------------- */
export const appendSearchArchive = () => {
  if ($('.section__search').length > 0 && $(window).width() < 832) {
    $('.section__filters-wrapper').prepend($('.section__search'))
  }
}

/* APPEND SEARCH ON ARCHIVE
  ----------------------------- */
export const checkForm = () => {
  if ($('.wpcf7-form[data-status="sent"]').length > 0) {
    $('.wpcf7-form[data-status="sent"] div:not(.wpcf7-response-output)').remove()
    window.location.hash = ''
  }
}

/* WORK HERO VIDEO CONTROLS
  ----------------------------- */
export const workVideoControls = () => {
  const playBtn = $('.section__video-play')
  const pauseBtn = $('.section__video-pause')
  const audioOnBtn = $('.section__video-audio-on')
  const audioOffBtn = $('.section__video-audio-off')
  const fullscreenBtn = $('.section__video-fullscreen')
  const video = document.getElementById("videoFull")

  playBtn.on('click', function () {
    video.play()
    playBtn.hide()
    pauseBtn.show()
  })

  pauseBtn.on('click', function () {
    video.pause()
    pauseBtn.hide()
    playBtn.show()
  })

  audioOnBtn.on('click', function () {
    video.muted = false
    audioOnBtn.hide()
    audioOffBtn.show()
  })

  audioOffBtn.on('click', function () {
    video.muted = true
    audioOffBtn.hide()
    audioOnBtn.show()
  })

  fullscreenBtn.on('click', function () {
    if (video.requestFullscreen) {
      video.requestFullscreen()
    } else if (video.webkitRequestFullscreen) { /* Safari */
      video.webkitRequestFullscreen()
    }
  })

  video.ontimeupdate = function () {
    var percentage = (video.currentTime / video.duration) * 100
    $('.section__video-progressbar').css('width', percentage + '%')
  }

  $('.section__video-progressbar-wrapper').on('click', function (e) {
    var offset = $(this).offset()
    var left = (e.pageX - offset.left)
    var totalWidth = $(this).width()
    var percentage = (left / totalWidth)
    var vidTime = video.duration * percentage
    video.currentTime = vidTime
  })

  const videoControls = $('.section__video-controls-wrapper,.section__video-close')
  const videoWrapper = $('.section__video-full-wrapper')
  let moveTimer

  videoWrapper.on("mousemove", function () {
    clearTimeout(moveTimer)
    videoControls.fadeIn(200)

    moveTimer = setTimeout(function () {
      videoControls.fadeOut(200)
    }, 2000)
  })
}

/* WORK AUTO-FILL FORM
  ----------------------------- */
export const workAutoFillForm = () => {
  if ($('select.wpcf7-select[name="position"]').length > 0 || $('.section__form-open-positions option').length > 0) {
    $('.section__form-open-positions option').appendTo('select.wpcf7-select[name="position"]')

    let searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has('position')) $('select.wpcf7-select[name="position"]').val(searchParams.get('position')).change()
  }
}

/* CONTACT US AUTO-FILL FORM
  ----------------------------- */
export const contactUsAutoFillForm = () => {
  var countrySelect = $('select.wpcf7-select[name="country"]')
  var provinceSelect = $('select.wpcf7-select[name="province"]')
  var countrySelectHidden = $('select#country-hidden')
  var provinceSelectHidden = $('select#province-hidden')

  countrySelect.on('change', function () {
    var selectedKey = $(this).val()
    var selectedKeyCode = ''

    // If Country has Province populate with the key code
    countrySelectHidden.find("option").each(function () {
      if ($(this).text() == selectedKey) selectedKeyCode = $(this).val()
    })

    // Then populate the Province select with all options that start with the key code and remove the key code from the value
    if (selectedKeyCode) {
      provinceSelect.find('option[value]:not([value=""]').remove()
      provinceSelect.append(provinceSelectHidden.find('option[value^=' + selectedKeyCode + ']'))
      provinceSelect.find('option').each(function () {
        var value = $(this).val()
        $(this).val(value.replace(selectedKeyCode + '-', ''))
      })
      provinceSelect.find("option:first").attr('selected', 'selected')
    }
  })
}

/* BLOG DRAGGABLE OVERFLOW SCROLL
  ----------------------------- */
export const blogDraggableOverflow = () => {
  const slider = document.querySelector('.section__filters-listing')
  let isDown = false
  let startX
  let scrollLeft

  slider.addEventListener('mousedown', (e) => {
    isDown = true
    slider.classList.add('active')
    startX = e.pageX - slider.offsetLeft
    scrollLeft = slider.scrollLeft
  })
  slider.addEventListener('mouseleave', () => {
    isDown = false
    slider.classList.remove('active')
  })
  slider.addEventListener('mouseup', () => {
    isDown = false
    slider.classList.remove('active')
  })
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - slider.offsetLeft
    const walk = (x - startX) * 2
    slider.scrollLeft = scrollLeft - walk
  });
}

/* UR FORM LABEL TOGGLE CLASS
  ----------------------------- */
export const urFormLabelToggle = () => {
  // PATCH BILLING PHONE FIELD
  $('#billing_phone label').attr('for', 'billing_phone')

  // PATCH BIRTHDAY FIELD
  $('.ur-flatpickr-field').on('focus blur input', function() {
    if ($(this).val().trim() !== '') {
      $(this).parents('.form-row').find('label').addClass('active')
    } else {
      $(this).parents('.form-row').find('label').removeClass('active')
    }
  })

  // LABEL TOGGLE
  $('.user-registration-Input,.ur-frontend-field,.ur-flatpickr-field').each(function () {
    const input = $(this)
    const label = $('label[for=' + input.attr('id') + ']')

    function toggleLabelClass() {
      if (input.is(':focus-visible') || input.val().trim() !== '') {
        label.addClass('active');
      } else {
        label.removeClass('active');
      }
    }

    input.on('focus blur input', toggleLabelClass)
    toggleLabelClass()
  })
}

/* WOO CART ADD TARGET BLANK TO PRODUCT NAME
  ----------------------------- */
export const wooCartProductLinkTarget = () => {
  if ($('.woocommerce-cart-form').length > 0) {
    $('.woocommerce-cart-form .product-name a').attr('target', '_blank')
  }
}

/* WOO CLOSE NOTICE WRAPPER
  ----------------------------- */
export const wooCloseNotice = () => {
  if ($('[class*="__woocommerce-notice-wrapper"]').length > 0) {
    $('[class*="__woocommerce-notice-wrapper"] [class*="__woocommerce-notice-close"]').on('click', function() {
      $(this).parent().remove()
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/functions.js